import { render } from "./FilterWilayahSemua.vue?vue&type=template&id=3df39bee"
import script from "./FilterWilayahSemua.vue?vue&type=script&lang=js"
export * from "./FilterWilayahSemua.vue?vue&type=script&lang=js"
script.render = render

export default script